import React, {useEffect, useState} from "react";
import { Form, Dropdown } from "react-bootstrap";

import './filter-panel.scss'

const FilterDefaultDropdown = ({row, nameParam, idParam, toggleRow, selectedRows, rowFilter}) => {
  const [checked, setChecked] = useState(false);
  const [name, setName] = useState([]);

  useEffect(() => {
    for (let i = 0; i < selectedRows.length; i++) {
      if (selectedRows[i][idParam] === row[idParam]) {
        setChecked(true);
        break;
      } else {
        setChecked(false);
      }
    }
    if (selectedRows.length === 0) {
      setChecked(false);
    }
    let newName = "";
    
    if (row[nameParam]?.length > 30) {
      for (let i = 0; i < 27; i++) {
        newName = newName.concat(row[nameParam][i]);
      }
      newName = newName.concat("...");
    } else {
      newName = row[nameParam];
    }
    setName(newName);
  }, [row, nameParam, toggleRow, selectedRows, rowFilter,idParam]);

  const toggleChecked = (e) => {
    toggleRow(row, !checked);
    setChecked(!checked);
  };

  return (
    <>
      <Form.Check className={"filter-panel-dropdown-row"}>
        <Form.Check.Input
          type="checkbox"
          checked={checked}
          onChange={(e) => {
            toggleChecked(e);
          }}
          style={{ left: "42px" }}
        />
        <div className={"filter-panel-dropdown-row-name ellipsis"}>{name}</div>
      </Form.Check>
      <Dropdown.Divider style={{ width: "478px" }}></Dropdown.Divider>
    </>
  );
};

export default FilterDefaultDropdown;
